import "../main.css";

export default function MenuGeoMarketing() {
  function isPaginaEspecifica(pagina) {
    return window.location.pathname === pagina;
  }

  const secoes = [
    {
      pagina: "/o-que-e-um-publico-potencial",
      titulo: "O que é um Público Potencial?",
      ativo: false,
    },

    {
      pagina: "/como-criar-um-publico-potencial",
      titulo: "Como criar um Público Potencial?",
      ativo: false,
    },

    {
      pagina: "/por-que-escolher-uma-regiao-geografica",
      titulo: "Por que escolher uma região geográfica?",
      ativo: false,
    },
  ];

  const menuSecoes = secoes.map((secao) => {
    return (
      <li key={secao.pagina} className="nav-item">
        <a
          className={`nav-link ${
            isPaginaEspecifica(secao.pagina) ? "active" : ""
          }`}
          href={isPaginaEspecifica(secao.pagina) ? undefined : secao.pagina}
        >
          {secao.titulo}
        </a>
      </li>
    );
  });

  return (
    <div>
      <h4>Artigos nessa seção</h4>
      <ul
        className="nav categories-nav nav-pills flex-column"
        role="navigation"
      >
        <li className="nav-item open">
          <ul className="nav nav-pills flex-column">{menuSecoes}</ul>
        </li>
      </ul>
    </div>
  );
}
